import React from 'react'

import { PhoneNotifications } from '../PhoneNotifications'

import { CardWrapper } from '../../CardWrapper'

export const NotificationsCardWrapper: React.FC = () => {  
  return (
    <CardWrapper
      title='Lembretes da consulta'
      subtitle='Escolha como quer receber seus lembretes'
    >
      <PhoneNotifications />
    </CardWrapper>
  )
}